<template>
    <div class="modal fade" id="modal_add_trainer" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestTrainer" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('views.clients.trainer.add') }}

                    </h5>
                    <button @click="closeModal('modal_add_trainer', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestTrainer">
                    <form class="forms-sample" @submit.prevent="submitForm">
                        <div class="row mb-3">

                            <div class="col-md-6  mb-2">
                                <radioInput v-model="isCaputre" :valueAttr="1" :label="i18n.t('button.upload_image')"
                                    :name="`isCaputre`" id="club-logo-1" />
                            </div>
                            <div class="col-md-6  mb-2">
                                <radioInput v-model="isCaputre" :valueAttr="0" :label="i18n.t('button.take_photo')"
                                    :name="`isCaputre`" id="club-logo-0" />
                            </div>
                        </div>
                        <div class="row  mb-4">
                            <div v-if="isCaputre" class="col-md-12 mb-3">
                                <div class="form-group mr-b-0em">
                                    <input-image v-model="requestTrainer.path_image"
                                        :label="i18n.t('tables.club.path_image')" :pathImage="image" :v="v$.path_image"
                                        :disabled="false" />
                                </div>
                            </div>
                            <div v-if="!isCaputre" class="col-md-12">
                                <capture-photo v-model="requestTrainer.path_image" :v="v$.path_image"
                                    :pathImage="image" />
                            </div>
                        </div>
                        <div class="row">
                            <!-- <div class="col-md-12 mb-3">
                                <div class="form-group mr-b-0em">
                                    <input-image v-model="requestTrainer.path_image"
                                        :label="i18n.t('tables.members.name')" :pathImage="image" :v="v$.path_image"
                                        :disabled="false" />
                                </div>
                            </div> -->
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <SingleSelect :TextLabel="i18n.t('tables.trainer.personType')" :trackby="`id`"
                                        :label="`name`" :valueProp="`id`" v-model="requestTrainer.personType"
                                        :placeholder="i18n.t('tables.trainer.personType')"
                                        :arrayOptions="personTypesList" :v="v$.personType" refs="personType" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <SingleSelect :TextLabel="i18n.t('tables.trainer.gender')" :trackby="`id`"
                                        :label="`name`" :valueProp="`id`" v-model="requestTrainer.gender"
                                        :placeholder="i18n.t('tables.trainer.gender')" :arrayOptions="filteredGenders"
                                        refs="gender" :v="v$.gender" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestTrainer.name" :label="i18n.t('tables.trainer.name')"
                                        :v="v$.name" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestTrainer.email" :label="i18n.t('tables.trainer.email')"
                                        :v="v$.email" :disabled="false" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <phone-number v-model="requestTrainer.tele" :label="i18n.t('tables.trainer.tele')"
                                        :v="v$.tele" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestTrainer.cin" :label="i18n.t('tables.trainer.cin')"
                                        :v="v$.cin" :disabled="false" />
                                </div>
                            </div>

                            <!-- <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestTrainer.dateBirth"
                                        :label="i18n.t('tables.trainer.dateBirth')" :v="v$.dateBirth" :fixedDays="1"
                                        :isFixedDays="true" />
                                </div>
                            </div> -->

                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestTrainer.adresse"
                                        :label="i18n.t('tables.trainer.adresse')" :v="v$.adresse" :disabled="false" />
                                </div>
                            </div>


                            <div v-if="requestTrainer.personType == 'coach'" class="col-md-12">
                                <div class="form-group mr-b-0em">
                                    <MultipSelect :TextLabel="i18n.t('tables.trainer.specialization')" :trackby="`name`"
                                        :label="`name`" :valueProp="`name`" v-model="requestTrainer.specialization"
                                        :placeholder="i18n.t('tables.trainer.specialization')"
                                        :arrayOptions="specializationsList" refs="specialization"
                                        :v="v$.specialization" />
                                </div>
                            </div>
                            <!-- <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <SingleSelect :TextLabel="i18n.t('tables.trainer.paymentType')" :trackby="`name`"
                                        :label="`name`" :valueProp="`name`" v-model="requestTrainer.paymentType"
                                        :placeholder="i18n.t('tables.trainer.paymentType')"
                                        :arrayOptions="paymentsTypesList" refs="paymentType" :v="v$.gender" />
                                </div>

                            </div> -->
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestTrainer.start_date"
                                        :label="i18n.t('tables.trainer.start_date')" :v="v$.start_date"
                                        :disabled="false" :fixedDays="1" :isFixedDays="false" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <SingleSelect :TextLabel="i18n.t('tables.trainer.contractType')" :trackby="`name`"
                                        :label="`name`" :valueProp="`name`" v-model="requestTrainer.contractType"
                                        :placeholder="i18n.t('tables.trainer.contractType')"
                                        :arrayOptions="contractsTypesList" refs="contractType" :v="v$.gender" />
                                </div>

                            </div>

                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <price-input v-model="requestTrainer.salary"
                                        :label="i18n.t('tables.trainer.salary')" :v="v$.salary" :disabled="false" />
                                </div>
                            </div>
                            <!-- <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <price-input v-model="requestTrainer.commissionRate"
                                        :label="i18n.t('tables.trainer.commissionRate')" :v="v$.commissionRate"
                                        :disabled="false" />
                                </div>
                            </div> -->



                            <div class="col-12 text-right">
                                <button type="submit" class="btn btn-primary mr-2">
                                    {{ action == 'add' ? i18n.t('button.add') : i18n.t('button.edit') }}
                                </button>
                                <button type="button" @click="emptyState()" class="btn btn-cancel">
                                    {{ i18n.t('button.clean') }}
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, watch, toRefs, computed } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
import MultipSelect from "@/components/inputsValidation/MultipSelect.vue";
import radioInput from "@/components/inputsValidation/radioInput.vue";



/*plugins*/
import { useVuelidate } from "@vuelidate/core";
import { required, email, minLength, helpers, maxLength } from "@vuelidate/validators";
import Swal from "sweetalert2";
import i18n from "@/i18n/index"

/*composables & states */
import { useTrainer } from "@/composables/trainer/useTrainer";
import { TrainerRequest } from "@/interfaces/trainer";
import { useModal } from '@/composables/modal/useModal';
import { useImageConverter } from '@/composables/global/useImageConverter';
import { usePermission } from "@/composables/auth/usePermission";
import { specializations, paymentsTypes, contractsTypes, genders, personTypes } from '@/shared/state';


export default defineComponent({
    components: { inputText, SingleSelect, MultipSelect, radioInput },
    name: "add-trainer",
    props: {
        trainer: {
            type: Object,
            default: null,
        }
    },
    setup(props) {

        const action = ref('add')
        const { trainer } = toRefs(props);
        const isCaputre = ref<any>(0)

        const requestTrainer = ref<TrainerRequest>({
            id: null,
            personType: null,
            matricule: null,
            name: null,
            email: null,
            tele: null,
            cin: null,
            adresse: null,
            path_image: null,
            dateBirth: null,
            gender: null,


            specialization: null,
            paymentType: 'salary',
            salary: null,
            commissionRate: null,
            start_date: null,

            contractType: null,


        });
        const personTypesList = computed(() => personTypes.value);
        const specializationsList = computed(() => specializations.value);
        const paymentsTypesList = computed(() => paymentsTypes.value);
        const contractsTypesList = computed(() => contractsTypes.value);
        const gendersList = computed(() => genders.value);


        const image = ref<any>(null)

        const { addTrainer, editTrainer, isRequestTrainer, errorTrainer } = useTrainer();
        const { selectedImage } = useImageConverter();
        const { hasPermission } = usePermission();

        const { closeModal } = useModal();



        const rules = {
            name: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 2, attribute: '' }),
                    minLength(2)
                ),
            },
            email: {
                email
            },
            tele: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 10, attribute: '' }),
                    minLength(10)
                ),
                maxLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 14, attribute: '' }),
                    maxLength(14)
                )
            },
            cin: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 4, attribute: '' }),
                    minLength(4)
                )
            },
            adresse: {
                //required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            path_image: {
                // required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            dateBirth: {
                //required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            gender: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },
            personType: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            }

        };
        const v$ = useVuelidate(rules, requestTrainer, { $scope: 'trainers' });


        /**
       * Add or edit trainer
       */
        const submitForm = async () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {
                if (action.value === "add") {
                    await addTrainer(requestTrainer.value);
                    if (!errorTrainer.value)
                        emptyState()
                } else {
                    Swal.fire({
                        title: i18n.t("message.confirmation.edit.title"),
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: i18n.t("button.edit"),
                        cancelButtonText: i18n.t("button.cancel"),
                        allowOutsideClick: false,   // ✅ disable closing by clicking outside
                        allowEscapeKey: false       // (optional) disable closing with ESC
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            await editTrainer(requestTrainer.value);
                            if (!errorTrainer.value)
                                emptyState()
                        }
                    });
                }
            }
        }




        const emptyState = () => {
            action.value = 'add';
            requestTrainer.value.personType = null
            requestTrainer.value.id = null
            requestTrainer.value.name = null
            requestTrainer.value.email = null
            requestTrainer.value.tele = null
            requestTrainer.value.cin = null
            requestTrainer.value.adresse = null
            requestTrainer.value.dateBirth = null
            requestTrainer.value.gender = null
            requestTrainer.value.path_image = null

            requestTrainer.value.specialization = null
            requestTrainer.value.paymentType = 'salary'
            requestTrainer.value.salary = null
            requestTrainer.value.commissionRate = null
            requestTrainer.value.start_date = null
            requestTrainer.value.contractType = null

            selectedImage.value = null
            image.value = null
            closeModal('modal_add_trainer', 'add')
            v$.value.$reset();
        };
        const initState = (trainer) => {
            if (trainer?.id) {
                action.value = 'edit';
                requestTrainer.value.personType = trainer.personType || null
                requestTrainer.value.id = trainer.id || null
                requestTrainer.value.name = trainer.name || null
                requestTrainer.value.email = trainer.email || null
                requestTrainer.value.tele = trainer.tele || null
                requestTrainer.value.cin = trainer.cin || null
                requestTrainer.value.adresse = trainer.adresse || null
                requestTrainer.value.dateBirth = trainer.dateBirth || null
                requestTrainer.value.gender = trainer.gender

                requestTrainer.value.specialization = trainer.specialization || null
                requestTrainer.value.paymentType = trainer.paymentType || 'salary'
                requestTrainer.value.salary = trainer.salary || null
                requestTrainer.value.commissionRate = trainer.commissionRate || null
                requestTrainer.value.start_date = trainer.start_date || null
                requestTrainer.value.contractType = trainer.contractType || null

                requestTrainer.value.path_image = null
                image.value = trainer?.path_image ? trainer?.path_image : null

                v$.value.$reset();
            } else {
                emptyState()
            }

        };


        watch(
            () => selectedImage.value,
            (newValue) => {
                requestTrainer.value.path_image = selectedImage.value
                image.value = selectedImage.value ?? null
            });
        watch(
            () => trainer.value,
            () => {
                initState(trainer.value)

            });



        const filteredGenders = computed(() => {
            return genders.value.filter(g => g.id === 0 || g.id === 1);
        });

        return {
            filteredGenders,
            isCaputre,
            submitForm,
            emptyState,
            action,
            v$,
            i18n,


            closeModal,
            isRequestTrainer,
            requestTrainer,
            image,
            hasPermission,
            specializationsList,
            paymentsTypesList,
            contractsTypesList,
            gendersList,
            personTypesList
        };
    },
});
</script>
